export const truncateDepartureTime = (time: string) => {
  if (time.charAt(0) === "0") {
    time = time.slice(1);
    return time.slice(0, 4);
  }
  return time.slice(0, 5);
};
